import React from 'react';
import { InputWrapper } from './input-wrapper';
import useSWR from 'swr';
import { fetcher } from '../../services/api';

import { CleanDeliveryOrder } from '../../export-types/cleaned-types';

import { FormattedMessage } from 'react-intl';

import { RetailDeliveryOrderDescriptionActions } from './retail-delivery-order-description-action';
import { ModalsService } from '../../services/modals.service';
import { RetailDeliveryDescriptionModal } from '../screens/delivery/retail-delivery-description-modal';

type DeliveryOrderDeliveryInfoProps = {
  id: string;
};
export const RetailDescriptionIfo: React.FC<DeliveryOrderDeliveryInfoProps> = (
  props,
) => {
  const { data: order } = useSWR<CleanDeliveryOrder>(
    `/delivery-order/${props.id}`,
    fetcher,
  );

  if (!order) {
    return null;
  }

  async function handleEditDescription() {
    if (!order) return;
    await ModalsService.createModal(RetailDeliveryDescriptionModal, {
      orderId: order.id,
      currentDescriptionRu: order.retailOrder?.description?.descriptionRu,
      currentDescriptionEn: order.retailOrder?.description?.descriptionEn,
      currentDescriptionCn: order.retailOrder?.description?.descriptionZh,
    });
  }

  return (
    <div>
      <div className="d-flex flex-row justify-content-between">
        <div className="fs-18 fw-600 color-gray-450">
          <FormattedMessage
            defaultMessage="Описание товара для таможни"
            id="retailDescriptionInfo.label.description"
            description="Информация о заказе"
          />
        </div>
        {!order.retailOrder?.hwbRefNumber && (
          <RetailDeliveryOrderDescriptionActions
            onEditDescription={handleEditDescription}
          />
        )}
      </div>
      <InputWrapper theme="light" className="mt-3">
        {order.retailOrder?.description?.descriptionRu}
      </InputWrapper>
      <InputWrapper theme="light" className="mt-3">
        {order.retailOrder?.description?.descriptionEn}
      </InputWrapper>
      <InputWrapper theme="light" className="mt-3">
        {order.retailOrder?.description?.descriptionZh}
      </InputWrapper>
    </div>
  );
};
